import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { fetchCreateBid } from '../../ducks/purchases.duck';

export const useCreatePurchase = () => {
  const dispatch = useDispatch();

  const createPurchase = useCallback(
    (id: number) => {
      dispatch(fetchCreateBid(id));
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      createPurchase,
    }),
    [createPurchase]
  );
};
